import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { ProductTemplateService } from '../product-template.service';
import { ProductConflictDTO, PublishProductFromTemplateDTO, ProductDTO, SellerProfileDTO } from '../../../../base/models/models.swagger.generated';
import { TemplateSelectionComponent } from './template-selection.component';
import { ConflictDetectionComponent } from './conflict-detection.component';
import { PublishingSummaryComponent } from './publishing-summary.component';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-publishing-wizard',
  standalone: true,
  imports: [CommonModule, TranslateModule, TemplateSelectionComponent, ConflictDetectionComponent, PublishingSummaryComponent, ButtonModule],
  templateUrl: './publishing-wizard.component.html',
  styleUrls: ['./publishing-wizard.component.scss']
})
export class PublishingWizardComponent implements OnInit, OnDestroy {
  public currentStep: number = 1;
  public selectedTemplateIds: number[] = [];
  public selectedSellerProfileId: number | null = null;
  public conflicts: ProductConflictDTO[] = [];
  public publishRequests: PublishProductFromTemplateDTO[] = [];
  public publishedProducts: ProductDTO[] = [];
  public sellerProfiles: SellerProfileDTO[] = [];
  public templateOverrides: Map<number, { price: number; quantity: number }> = new Map();
  private _subscription: Subscription = new Subscription();

  constructor(
    private productTemplateService: ProductTemplateService,
    private router: Router
  ) { }

  ngOnInit() {
    this.loadSellerProfiles();
  }

  private loadSellerProfiles() {
    this._subscription.add(
      this.productTemplateService.getSellerProfiles().subscribe((profiles) => {
        this.sellerProfiles = profiles;
      })
    );
  }

  public onTemplatesSelected(data: { templateIds: number[], sellerProfileId: number }) {
    this.selectedTemplateIds = data.templateIds;
    this.selectedSellerProfileId = data.sellerProfileId;
    this.checkConflicts();
  }

  private checkConflicts() {
    this._subscription.add(
      this.productTemplateService.checkConflicts(this.selectedTemplateIds).subscribe((conflicts) => {
        this.conflicts = conflicts;
        this.currentStep = 2;
      })
    );
  }

  public onConflictsResolved(requests: PublishProductFromTemplateDTO[]) {
    this.publishRequests = requests;
    this.currentStep = 3;
  }

  public onPublish() {
    this._subscription.add(
      this.productTemplateService.publishTemplates(this.publishRequests).subscribe((products) => {
        this.publishedProducts = products;
      })
    );
  }

  public goBack() {
    if (this.currentStep > 1) {
      this.currentStep--;
    } else {
      this.router.navigate(['/product-template']);
    }
  }

  public close() {
    this.router.navigate(['/product-template']);
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }
}
